import classNames from 'classnames'
import { useMediaQueryContext } from '@context'
import Text from '@components/Ui/Text'
import Icon from '@components/Ui/Icon'
import styles from './ProgressDot.scss'

const ProgressDot = ({ number, text, active, checked, disabled, onClick }) => {
  const { md } = useMediaQueryContext()

  return (
    <div
      className={classNames(styles.base, { [styles.active]: active, [styles.checked]: checked })}
      onClick={checked ? onClick : null}
    >
      {!checked && (
        <Text type="robo_md_bold" className={styles.number}>
          {number}
        </Text>
      )}
      {checked && (
        <div className={styles.number}>
          <Icon type="check" />
        </div>
      )}
      {md && (
        <Text type="robo_md_bold" className={styles.text}>
          {text}
        </Text>
      )}
    </div>
  )
}

ProgressDot.defaultProps = {
  number: '1',
  text: 'XX',
  active: false,
  disabled: false,
}
ProgressDot.propTypes = {}

export default ProgressDot
